import { IOnePageInfo } from "@/types/types";
import React, { useState, useEffect } from "react";
import { useSmartNavigate } from "@/hooks";
import { Spin } from "antd";
import { findMenuTreeNode } from "@/utils/menu";
import { getMenus, getLowcodePageInfo } from "@/services";
import { getEffectivePagePath } from "@/utils";
import RenderLowcodePage from "@/pages/render-lowcode-page";
import styles from "../index.module.css";

const FormDetailPage = ({ onePageInfo }: { onePageInfo?: IOnePageInfo }) => {
  const navigate = useSmartNavigate(onePageInfo);
  // 获取有效的低码页面path, 优先从onePageInfo中取
  const path = onePageInfo?.innerPagePath
    ? onePageInfo.innerPagePath
    : getEffectivePagePath();
  const [pageId, setPageId] = useState("");
  const [detailSchema, setDetailSchema] = useState(null); // 表单编辑页的schema
  const [nodePermitList, setNodePermitList] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * path变化时说明发生了页面切换, 需要重新获取页面信息
   */
  useEffect(() => {
    const getFormDetailPageSchema = async () => {
      const { menus } = await getMenus();
      const node = findMenuTreeNode(menus, path); // 找到这个path对应菜单项的详细信息
      if (node && node.pageId) {
        // 当前path是CREATE页面, DETAIL / UPDATE 不是实体页面, 都挂在这个菜单path下
        try {
          // 1. 取当前CREATE页面关联的页面信息
          const { relatedPageInfoList } = await getLowcodePageInfo(node.pageId);
          // 2. 找到DETAIL页id, TODO: 暂时保持现状, 取第一个, 后续需要考虑指定datasetId
          const detailPageId = relatedPageInfoList?.[0]?.pageInfo.find(
            ({ type }) => type === "DETAIL",
          )?.id;
          // 3. 根据 DETAIL id 取完整页面信息
          const pageInfo = await getLowcodePageInfo(detailPageId);
          // 4. 获取 schema
          const detailCode = JSON.parse(pageInfo.code);
          // 5. setState
          setDetailSchema(detailCode || null);
          setNodePermitList(pageInfo.nodePermitList || []);
          setPageId(node.pageId);
        } catch (error) {
          console.warn("error", error);
        } finally {
          setLoading(false); // 取消 loading
        }
      }
    };
    getFormDetailPageSchema();
  }, [path]);

  return (
    <Spin tip="Loading..." spinning={loading}>
      <div className={styles.lowcodePage}>
        <RenderLowcodePage
          key={pageId}
          schema={detailSchema}
          nodePermitList={nodePermitList}
          pageId={pageId}
          location={location}
          navigate={navigate}
          onePageInfo={onePageInfo}
        />
      </div>
    </Spin>
  );
};

export default FormDetailPage;
